export default {
    configuration: true,
    table: {
        height: 500,
        columns: [
            {
                label: '序号',
                prop: 'id',
                sort: true,
                width: 150,
                amendState: true
            },
            {
                label: '外部节点',
                prop: 'isOuterName',
                sort: true,
                width: 150
            },
            {
                label: '类型',
                prop: 'typeName',
                sort: true,
                width: 150
            },
            {
                label: '发车单号',
                prop: 'dispatchNo',
                sort: true,
                width: 150
            },
            {
                label: '是否异常',
                prop: 'isAbnormalName',
                sort: true,
                width: 150
            },
            {
                label: '是否在线',
                prop: 'mobileOnlineName',
                sort: true,
                width: 150
            },
            {
                label: '登录手机号码',
                prop: 'mobile',
                sort: true,
                width: 182
            },
            {
                label: '网络和GPS',
                sort: true,
                prop: 'statusName',
                width: 120
            },
            {
                label: '经度',
                sort: true,
                prop: 'longitude',
                width: 120
            },
            {
                label: '纬度',
                sort: true,
                prop: 'latitude',
                width: 120
            },
            {
                label: '手机设备类型',
                sort: true,
                prop: 'mobileType',
                width: 120
            },
            {
                label: '手机版本',
                prop: 'mobileVersion',
                sort: true,
                width: 160
            },
            {
                label: '速度',
                prop: 'speed',
                sort: true,
                width: 160
            },
            {
                label: 'app版本',
                prop: 'appVersion',
                sort: true,
                width: 160
            },
            {
                label: '省名称',
                prop: 'trackingProvinceName',
                sort: true,
                width: 160
            },
            {
                label: '市名称',
                prop: 'trackingCityName',
                sort: true,
                width: 160
            },
            {
                label: '市编码',
                prop: 'trackingCityCode',
                sort: true,
                width: 160
            },
            {
                label: '区/县名称',
                prop: 'trackingDistrictName',
                sort: true,
                width: 160
            },
            {
                label: '镇/街道名称',
                prop: 'trackingTownName',
                sort: true,
                width: 160
            },
            {
                label: '跟踪地点名称',
                prop: 'trackingLocationName',
                sort: true,
                width: 160
            },
            {
                label: '跟踪时间',
                prop: 'trackingDate',
                sort: true,
                width: 160
            },
            {
                label: '跟踪方式',
                prop: 'trackingWayName',
                sort: true,
                width: 160
            },
            {
                label: '备注',
                prop: 'remark',
                sort: true,
                width: 160
            },
            {
                label: '跟踪来源',
                prop: 'trackingSourceName',
                sort: true,
                width: 160
            },
            {
                label: '是否推送查单系统',
                prop: 'trackingChadanFlagName',
                sort: true,
                width: 160
            },
            {
                label: '设备号',
                prop: 'deviceNo',
                sort: true,
                width: 160
            },
            {
                label: '设备类型',
                prop: 'deviceTypeName',
                sort: true,
                width: 160
            },
            {
                label: '创建人',
                prop: 'createUserName',
                sort: true,
                width: 160
            },
            {
                label: '创建时间',
                prop: 'createTime',
                sort: true,
                width: 160
            },
            {
                label: '修改人',
                prop: 'updateUserName',
                sort: true,
                width: 160
            },
            {
                label: '修改时间',
                prop: 'updateTime',
                sort: true,
                width: 160
            }
        ]
    },
    page: {
        layout: 'total, sizes, prev, pager, next',
        pageSize: 10,
        pageSizes: [
            10,
            20,
            30,
            50
        ]
    }

};
